import React from "react"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { refreshFileRequest } from "@api/file_request/"
import humanFileSize from "@src/helpers/humanFileSize"
import { DEFAULTS } from "@constants"
import { GLOBALS } from "@src/config"

/**
 * Shows files being imported (copied) from CineSend Files into this request as rows above the
 * provided-files list, mirroring the active-uploads section. Polls while any copy is running and
 * refreshes the request once they finish so the provided list updates.
 */
class CopyImports extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      files: []
    }
  }
  componentDidMount() {
    this.poll()
  }
  componentDidUpdate(prevProps) {
    // A supply request just completed posting; start watching for its copies.
    if (prevProps.request.import_status === "PENDING" && this.props.request.import_status !== "PENDING") {
      this.startPolling()
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval)
  }
  startPolling() {
    clearInterval(this.interval)
    this.poll()
    this.interval = setInterval(() => this.poll(), 4000)
  }
  poll() {
    const { request } = this.props
    if (!request._id) {
      return
    }
    const param = request.type === "cinerequest" ? "cinerequestID" : "fileRequestID"
    fetch(`${GLOBALS.API_URL}/files/copy-progress?${param}=${request._id}`, DEFAULTS)
      .then(res => res.json())
      .then(res => {
        const files = (res.files || []).filter(file => ["pending", "copying", "failed"].includes(file.copy_status))
        const hadActive = this.state.files.some(file => file.copy_status !== "failed")
        const hasActive = files.some(file => file.copy_status !== "failed")
        this.setState({ files })

        if (!hasActive) {
          clearInterval(this.interval)
          this.interval = null

          // The active copies just finished; refresh the provided-files list.
          if (hadActive) {
            this.props.refreshFileRequest()
          }
        }
        else if (!this.interval) {
          this.interval = setInterval(() => this.poll(), 4000)
        }
      })
      .catch(() => {})
  }
  render() {
    const { files } = this.state
    if (!files.length) {
      return null
    }
    return (
      <div className='max-width-3 mx-auto mt2'>
        <strong className='block muted'>Active Imports ({files.length})</strong>
        <small className='block muted mb1'>
          You can safely leave this page — imports will continue in the background.
        </small>
        {files.map(file => (
          <div key={file._id} className='bg-white rounded box-shadow p2 mb1 max-width-3 mx-auto'>
            <div className='flex items-center'>
              <div className='flex-auto'>
                <strong className='truncate block'>{file.name}</strong>
                <div className='bg-gray-5 rounded relative pt1 overflow-hidden my1 flex-auto'>
                  <div
                    style={{ width: `${file.copy_progress || 0}%` }}
                    className='absolute top-0 left-0 bottom-0 overflow-hidden z4 col-12 bg-green progress'/>
                </div>
                <div className='flex items-center justify-between'>
                  <div>
                    {file.copy_status === "failed"
                      ? "Import failed"
                      : `Importing - ${humanFileSize(file.copied_bytes) || "0 B"} / ${humanFileSize(
                        file.copy_total_bytes
                      ) || "--"} - ${file.copy_progress || 0}%`}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

CopyImports.propTypes = {
  request: PropTypes.object.isRequired,
  refreshFileRequest: PropTypes.func.isRequired
}

const mapStateToProps = ({ file_request }) => ({
  request: file_request
})

const mapDispatchToProps = dispatch => ({
  refreshFileRequest: bindActionCreators(refreshFileRequest, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CopyImports)
